// removed by extract-text-webpack-plugin
module.exports = {"filled":"_1zxhJIM","pop":"_2FcwF1y"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/icons/HeartIcon/HeartIcon.less
 ** module id = 643
 ** module chunks = 0
 **/